import {
  FETCH_PROJECT_ALERTS_CONFIRMATIONS,
  CLEAR_PROJECT_ALERTS_CONFIRMATIONS
} from '#action/types';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_PROJECT_ALERTS_CONFIRMATIONS:
      return { ...state, [action.id]: action.payload };
    case CLEAR_PROJECT_ALERTS_CONFIRMATIONS:
      return defaultState;
    default:
      return state;
  }
};
